import { colorsPalettes } from "@similarweb/styles";

import type { ThemeColors, TopicTrafficChangeState } from "./types";

export const getState = (
    change: number | null | undefined,
    stagnationFrom: number,
    stagnationTo: number,
): TopicTrafficChangeState => {
    if (change === null || change === undefined || !Number.isFinite(change)) {
        return "empty";
    }
    if (change < stagnationFrom) {
        return "declining";
    }
    if (change > stagnationTo) {
        return "growing";
    }

    return "stagnating";
};

export const getColors = (state: TopicTrafficChangeState): ThemeColors => {
    switch (state) {
        case "growing":
            return { bg: colorsPalettes.green[100], blockBg: colorsPalettes.green["400_P"], text: "#fff" };
        case "declining":
            return { bg: colorsPalettes.red[100], blockBg: colorsPalettes.red["400_P"], text: "#fff" };
        case "stagnating":
            return { bg: colorsPalettes.carbon[25], blockBg: colorsPalettes.carbon[250], text: "#fff" };
        case "empty":
        default:
            return { bg: colorsPalettes.carbon[25], blockBg: colorsPalettes.carbon[250], text: "#fff" };
    }
};
